import {
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react"

function AssistedLaunchModal({
  isOpen,
  onClose,
}: {
  isOpen: boolean
  onClose: () => void
}) {
  return (
    <Modal
      closeOnOverlayClick={false}
      isOpen={isOpen}
      size="4xl"
      onClose={() => onClose()}
    >
      <ModalOverlay backdropFilter="blur(5px)" />
      <ModalContent>
        <ModalHeader
          borderBottomColor="gray.100"
          borderBottomWidth={1}
          p={4}
          textStyle="h5"
        >
          <HStack>
            <Text>Get Tally&apos;s assistance</Text>
          </HStack>
          <ModalCloseButton />
        </ModalHeader>
        <ModalBody px={4} py={4}>
          <iframe
            height="645"
            src="https://docs.google.com/forms/d/e/1FAIpQLSfXu1dUlNO2epCpgzy3hjYOe6iLaPas1eSY6mRP4aTcWrqlhw/viewform?embedded=true"
            title="hi"
            width="100%"
          >
            Loading…
          </iframe>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default AssistedLaunchModal
